/**
 * @description 險種 Sid (enum)
 */
export enum InsuranceSidEnum {
  /** 全部 */
  All = 'All',
  /** 旅平險 */
  Travel = 'Travel',
  /** 小額終老險 */
  Old = 'Old',
  /** 重大疾病險 */
  Disease = 'Disease',
  /** 壽險 */
  Life = 'Life'
}
